<script>
import { AnalyticsHandler } from '@Foundation/analyticsHandler';
import { inViewport } from '@Foundation/utilities';

const bvReviewsSelector = '.bvReviews.reviews-container';
export default {
  name: 'BazaarvoiceTagging',
  props: {
    taggingData: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      isScrolledContent: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      const bvWrapper = document.querySelector(".bvReviews__wrapper div[data-bv-show='reviews']");
      if (bvWrapper && bvWrapper.shadowRoot) {
        const bvReviewsV2 = bvWrapper.shadowRoot.getElementById('reviews_container');
        if (bvReviewsV2 && bvReviewsV2.hasChildNodes() && inViewport(bvReviewsV2)) {
          this.sendTaggingData();
        }
      }
    },
    sendTaggingData() {
      window.removeEventListener('scroll', this.onScroll);
      const isTaggingDataExist = !!Object.keys(this.taggingData).length;
      isTaggingDataExist && AnalyticsHandler.pushDataLayer(this.taggingData);
    },
  },
};
</script>



